module.exports = __webpack_public_path__ + "static/media/la-solid-900.8c65fd3e.eot";